import React, { useEffect, useState } from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
// FLATBUFFERS SCHEMAS
import { Traffic } from "../../../../flatbuffers/generated/traffic/traffic";
import { Usage } from "../../../../flatbuffers/generated/usage/usage";
import { Service } from "../../../../flatbuffers/generated/service/service";
import { Control } from "../../../../flatbuffers/generated/control/control";
import { Fault } from "../../../../flatbuffers/generated/fault/fault";
import { GroupSupervisoryStatus } from "../../../../flatbuffers/generated/group-supervisory-status/group-supervisory-status";
import { GroupControl } from "../../../../flatbuffers/generated/group-control/group-control";
import { ControllerInfoContent } from "../../../../flatbuffers/generated/controller-info/controller-info-content";
import { Status } from "../../../../flatbuffers/generated/status/status";
// INTERFACES
import { EncodedMessageContent } from "../../../../flatbuffers/generated/ln2/encoded-message-content";
import { MessageContent } from "../../../../flatbuffers/generated/ln2/message-content";
import { LiftType } from "../../../../interfaces/Lift.interface";

export default function IconDefinitionMessagesCatalog({
  message,
  onChangeMessage,
  disabled,
  liftType,
  contentType,
  messageType,
}: {
  message: number | null;
  onChangeMessage: (newValue: number) => void;
  disabled: boolean;
  liftType: LiftType;
  contentType: EncodedMessageContent | null;
  messageType: MessageContent | MessageContent | null;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  interface CatalogInterface {
    label: string;
    value: number;
  }

  const { Option } = Select;

  // ************************************************ */
  // FLAT BUFFERS SCHEMAS CATALOGS ****************** */
  const elevatorTrafficOptions: CatalogInterface[] = Object.entries(Traffic)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const escalatorTrafficOptions: CatalogInterface[] = Object.entries(Traffic)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const elevatorUsageOptions: CatalogInterface[] = Object.entries(Usage)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const escalatorUsageOptions: CatalogInterface[] = Object.entries(Usage)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const elevatorServiceOptions: CatalogInterface[] = Object.entries(Service)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const escalatorServiceOptions: CatalogInterface[] = Object.entries(Service)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const elevatorControlOptions: CatalogInterface[] = Object.entries(Control)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const escalatorControlOptions: CatalogInterface[] = Object.entries(Control)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const elevatorFaultOptions: CatalogInterface[] = Object.entries(Fault)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const escalatorFaultOptions: CatalogInterface[] = Object.entries(Fault)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const elevatorGroupSupervisoryStatusOptions: CatalogInterface[] = Object.entries(
    GroupSupervisoryStatus,
  )
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const escalatorGroupSupervisoryStatusOptions: CatalogInterface[] = Object.entries(
    GroupSupervisoryStatus,
  )
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const elevatorGroupControlOptions: CatalogInterface[] = Object.entries(GroupControl)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const escalatorGroupControlOptions: CatalogInterface[] = Object.entries(GroupControl)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const elevatorControllerInfoOptions: CatalogInterface[] = Object.entries(ControllerInfoContent)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const escalatorControllerInfoOptions: CatalogInterface[] = Object.entries(ControllerInfoContent)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const elevatorStatusOptions: CatalogInterface[] = Object.entries(Status)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  const escalatorStatusOptions: CatalogInterface[] = Object.entries(Status)
    .filter(([, v]) => typeof v === "number")
    .map(([label, value]: any) => ({
      label,
      value,
    }));

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [catalog, setCatalog] = useState<CatalogInterface[]>([]);

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */
  useEffect(() => {
    // si no hay selección, no hay catálogo
    if (contentType == null || messageType == null) {
      setCatalog([]);
      return;
    }

    // OneHot => Usage / Service
    if (contentType === EncodedMessageContent.OneHotMessage) {
      if (messageType === MessageContent.Usage_UsageMessage) {
        setCatalog(
          liftType === LiftType.ELEVATOR ? [...elevatorUsageOptions] : [...escalatorUsageOptions],
        );
        return;
      }
      if (messageType === MessageContent.Service_ServiceMessage) {
        setCatalog(
          liftType === LiftType.ELEVATOR
            ? [...elevatorServiceOptions]
            : [...escalatorServiceOptions],
        );
        return;
      }

      setCatalog([]);
      return;
    }

    // BitMask => Traffic / Status / Control / Fault / Group... / ControllerInfo
    if (contentType === EncodedMessageContent.BitMaskMessage) {
      if (messageType === MessageContent.Traffic_TrafficMessage) {
        setCatalog(
          liftType === LiftType.ELEVATOR
            ? [...elevatorTrafficOptions]
            : [...escalatorTrafficOptions],
        );
        return;
      }
      if (messageType === MessageContent.Status_StatusMessage) {
        setCatalog(
          liftType === LiftType.ELEVATOR ? [...elevatorStatusOptions] : [...escalatorStatusOptions],
        );
        return;
      }
      if (messageType === MessageContent.Control_ControlMessage) {
        setCatalog(
          liftType === LiftType.ELEVATOR
            ? [...elevatorControlOptions]
            : [...escalatorControlOptions],
        );
        return;
      }
      if (messageType === MessageContent.Fault_FaultMessage) {
        setCatalog(
          liftType === LiftType.ELEVATOR ? [...elevatorFaultOptions] : [...escalatorFaultOptions],
        );
        return;
      }
      if (messageType === MessageContent.GroupSupervisoryStatus_GroupSupervisoryStatusMessage) {
        setCatalog(
          liftType === LiftType.ELEVATOR
            ? [...elevatorGroupSupervisoryStatusOptions]
            : [...escalatorGroupSupervisoryStatusOptions],
        );
        return;
      }
      if (messageType === MessageContent.GroupControl_GroupControlMessage) {
        setCatalog(
          liftType === LiftType.ELEVATOR
            ? [...elevatorGroupControlOptions]
            : [...escalatorGroupControlOptions],
        );
        return;
      }
      if (messageType === MessageContent.ControllerInfo_ControllerInfoMessage) {
        setCatalog(
          liftType === LiftType.ELEVATOR
            ? [...elevatorControllerInfoOptions]
            : [...escalatorControllerInfoOptions],
        );
        return;
      }

      setCatalog([]);
      return;
    }

    setCatalog([]);
  }, [liftType, contentType, messageType]);

  useEffect(() => {
    if (catalog.length > 0) {
      onChangeMessage(catalog[0].value);
    }
  }, [catalog]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Select
      optionFilterProp="children"
      className="generalStyles__width100"
      allowClear={false}
      size="small"
      value={message ?? undefined}
      onChange={(e: number) => onChangeMessage(e)}
      disabled={disabled}
    >
      {catalog.map((item) => (
        <Option key={item.label} value={item.value}>
          <FontAwesomeIcon
            icon={faCircle}
            className="generalStyles__success"
            style={{ marginRight: "10px" }}
          />
          {item.label}
        </Option>
      ))}
    </Select>
  );
}
